import { render, staticRenderFns } from "./zDialogoImpressao.vue?vue&type=template&id=09ce8c40&scoped=true&"
import script from "./zDialogoImpressao.vue?vue&type=script&lang=js&"
export * from "./zDialogoImpressao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ce8c40",
  null
  
)

export default component.exports